(function ($, root, undefined) {
    
    'use strict';

    if($('div').hasClass('cs-accordion')===true){
        $('div.cs-accordion').each(function(){
            $(this).on('click', 'a.title', function(e){
                e.preventDefault();
                if($(this).parent().hasClass('active')===true){
                    $(this).parent().removeClass('active');
                }else{
                    $(this).parent().addClass('active');
                }
            })
        });
    }


    $(document).on('click', '._scrollTo', function(e){
        e.preventDefault()
        let id = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(id).offset().top
        }, 1000);
    })



    var slider = function (container, options) {

        var setting = $.extend({
            items       : 1,
            autoplay    : true,
            interval    : 3000,
            loop        : false,
            callback    : function () {
            }
        }, options);

        var ANIMATE_SPEED = 500;

        var $slider = $(container);
        var $sliderControlNav = $slider.find('.cs-carousel_control-nav');
        var $sliderArrowLeft = $slider.find('.cs-carousel_arrow__left');
        var $sliderArrowRight = $slider.find('.cs-carousel_arrow__right');
        var $sliderList = $slider.find('.cs-carousel_list');
        var $sliderItemsList = $slider.find('.cs-carousel_item');
        var slidesCount = $sliderItemsList.length;
        var slideWidth = $slider.find('.cs-carousel_viewport').width();
        console.log('slideWidth',slideWidth)
        var currentSlide = 0;
        var $sliderControlNavList;
        var $firstSlideClone = $sliderList.children().slice(slidesCount-setting.items).clone();
        var $lastSlideClone = $sliderList.children().slice(0, setting.items).clone();
        var isAnimating = false;
        var sliderInterval;

        var init = function () {
            $firstSlideClone.prependTo($sliderList);
            $lastSlideClone.appendTo($sliderList);
            setCountOfSlidesInViewPort();
            createControlNavItems();
            $sliderList.css('transform', 'translate(' + -(slideWidth * setting.items) + 'px)');
            attachHandlers();
            if (!setting.loop) {
                $sliderArrowLeft.hide();
            }
            setSliderInterval();
        };

        var attachHandlers = function () {
            $sliderArrowLeft.on('click', function () {
                setSlide('prev');
            });
            $sliderArrowRight.on('click', function () {
                setSlide('next');
            });
            $sliderControlNav.on('click', '.cs-carousel_control-nav-item', function () {
                setSlide($(this).index());
            });
        };

        var setCountOfSlidesInViewPort = function () {
            if (setting.items > 1) {
                slideWidth = slideWidth / setting.items;
            }
            $sliderList.width(slideWidth * (slidesCount + setting.items * 2));
            $slider.find('.cs-carousel_item').each(function (i) {
                $(this).css('width', slideWidth).addClass('slider_item-' + i);
            });
        };

        var createControlNavItems = function () {
            var $sliderControlNavItem;

            for (var i = 0; i < slidesCount; i++) {
                $sliderControlNavItem = $('<div class="cs-carousel_control-nav-item">');
                $sliderControlNav.append($sliderControlNavItem);
            }

            $sliderControlNavList = $sliderControlNav.find('.cs-carousel_control-nav-item');
            $sliderControlNavList.eq(currentSlide).addClass('is-active');
        };

        var setSlide = function (arg) {

            if (!isAnimating) {

                isAnimating = true;

                if (typeof(arg) === 'number' && arg === -1) {
                    isAnimating = false;
                    return;
                }

                clearSliderInterval();

                if (arg === 'next') {
                    if (currentSlide < slidesCount - 1) {
                        currentSlide++;
                        slideAnimate();
                        setCurrentNavItem(currentSlide);
                        $sliderList.css('transform', 'translate(' + -(currentSlide + setting.items) * slideWidth + 'px)');
                    } else if (setting.loop && currentSlide === slidesCount - 1) {
                        currentSlide++;
                        slideAnimate();
                        setCurrentNavItem(0);
                        $sliderList.css('transform', 'translate(' + -(currentSlide + setting.items) * slideWidth + 'px)');
                        setTimeout(function () {
                            currentSlide = 0;
                            $sliderList.css('transform', 'translate(' + -(currentSlide + setting.items) * slideWidth + 'px)');
                        }, ANIMATE_SPEED);
                    }

                    if (!setting.loop && currentSlide === slidesCount - 1) {
                        isAnimating = false;
                    }

                    if (!setting.loop && currentSlide === slidesCount - 1) {
                        $sliderArrowRight.hide();
                    }

                    if (!setting.loop && currentSlide === 1) {
                        $sliderArrowLeft.show();
                    }
                }

                if (arg === 'prev') {
                    if (currentSlide > 0) {
                        currentSlide--;
                        slideAnimate();
                        setCurrentNavItem(currentSlide);
                        $sliderList.css('transform', 'translate(' + -(currentSlide + setting.items) * slideWidth + 'px)');
                    } else if (setting.loop && currentSlide === 0) {
                        slideAnimate();
                        setCurrentNavItem(slidesCount - 1);
                        $sliderList.css('transform', 'translate(' + -slideWidth * (setting.items - 1) + 'px)');
                        setTimeout(function () {
                            currentSlide = slidesCount - 1;
                            $sliderList.css('transform', 'translate(' + -(currentSlide + setting.items) * slideWidth + 'px)');
                        }, ANIMATE_SPEED);
                    }

                    if (!setting.loop && currentSlide === 0) {
                        isAnimating = false;
                    }

                    if (!setting.loop && currentSlide === 0) {
                        $sliderArrowLeft.hide();
                    }

                    if (!setting.loop && currentSlide === slidesCount - 2) {
                        $sliderArrowRight.show();
                    }
                }

                if (typeof(arg) === 'number' && arg >= 0) {
                    currentSlide = arg;
                    slideAnimate();
                    setCurrentNavItem(currentSlide);
                    $sliderList.css('transform', 'translate(' + -(currentSlide + setting.items) * slideWidth + 'px)');
                    if (!setting.loop && currentSlide === 0) {
                        $sliderArrowLeft.hide();
                    }
                    if (!setting.loop && currentSlide === slidesCount - 1) {
                        $sliderArrowRight.hide();
                    }
                    if (!setting.loop && currentSlide > 0) {
                        $sliderArrowLeft.show();
                    }
                    if (!setting.loop && currentSlide < slidesCount - 1) {
                        $sliderArrowRight.show();
                    }
                }

                setSliderInterval();
            }

            setting.callback(currentSlide);

        };

        var slideAnimate = function () {
            $sliderList.addClass('is-animating');
            setTimeout(function () {
                $sliderList.removeClass('is-animating');
                isAnimating = false;
            }, ANIMATE_SPEED);
        };

        var setCurrentNavItem = function (slideNumber) {
            $sliderControlNavList.removeClass('is-active');
            $sliderControlNavList.eq(slideNumber).addClass('is-active');
        };

        var disableArrowRight = function () {
            if (currentSlide === slidesCount - 1) {
                $sliderNavBtnRight.hide();
            } else {
                $sliderNavBtnRight.show();
            }
        };

        var disableArrowLeft = function () {
            if (currentSlide === 0) {
                $sliderNavBtnLeft.hide();
            } else {
                $sliderNavBtnLeft.show();
            }
        };

        var setSliderInterval = function () {
            if (setting.autoplay) {
                sliderInterval = setInterval(function () {
                    setSlide('next');
                }, setting.interval);
            }
        };

        var clearSliderInterval = function () {
            if (setting.autoplay) {
                clearInterval(sliderInterval);
            }
        };

        this.getSlidesCount = function () {
            return slidesCount;
        };

        init();
    };

    $.fn.slider = function (options) {

        if (options === undefined) {
            options = {};
        }

        if (typeof options === 'object') {
            return new slider(this, options);
        }
    }


    if($('div').hasClass('cs-carousel')===true){
        setTimeout(function(){
            $('div.cs-carousel').each(function(){
                let $slider = $(this).slider();
            })
        },1000)
        
        $(window).resize(function(){
            $('div.cs-carousel').each(function(){
                let $slider = $(this).slider();
            })
        })
    }


    // if($('a').hasClass('_expand')===true){
    //     $('a._expand').each(function(){
    //         $(this).on('click',function(e){
    //             e.preventDefault();
    //             if($(this).hasClass('active')===true){
    //                 $(this).removeClass('active')
    //             }else{
    //                 $(this).addClass('active')
    //             }
    //         })
    //     })
    // }
    $('a._expand').each(function(){
        $(this).on('click',function(e){
            e.preventDefault();
        })
    })



    // zE(function() {
    //     zE.activate();
    // })
        
    // function show() {
    //     zE.show();
    //     zE.activate();
    // }


})(window.jQuery, this);